import { Http, HttpModule } from '@angular/http';

import { Injectable } from '@angular/core';

// import { M_CLCARD } from '../../models/M_CLCARD';
// import { Database } from '../../providers/database';
import { Ortak } from '../../providers/ortak';
import { Servis } from '../../providers/servis';


/*
  Generated class for the BllCariKart provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BllOrtak {
  geribildirimurl="http://demoteknikservis.netlifeyazilim.com/Api/Servis.aspx?key=N9ySoNLaS2_18&t=";
  constructor(public servis: Servis, public ortak: Ortak) {

  }


  islem(formData: FormData, method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makePostRequest(this.ortak.ServisUrl + method, formData).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
         
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
          console.log(sonuc);
          console.log("asdd",method,formData);
          err(sonuc.Exception);

        }
        else
          res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
        err(x);
      })

    })
  }

  
  etiketbas(formData: FormData, method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makePostRequest(this.ortak.ServisUrl + method, formData).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
         
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
       
          err(sonuc.Exception);

        }
        else
          res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
          
         err(x);
      })

    })
  }
  geribildirim(formData: FormData, method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makePostRequest(this.geribildirimurl+ method, formData).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
         
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
          
         // err(sonuc.Exception);

        }
        else
          res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
       // err(x);
      })

    })
  }

  islemWithoutPost(method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makeGetRequest(this.ortak.ServisUrl + method).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
         // this.ortak.showBasicAlert("Hata", sonuc.Exception);
        }
        res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
       // err(x);
      })

    })
  }

  masaDetaylari(masaID, masa_adi, bolgeID,siparisDurumID) {
    return new Promise((res, err) => {
      var formData = new FormData();

      var rezerveDurum = 0;
      var kaynakRef = masaID;
      var rezerveEden = "";
      var siparisTip = "1";
      var kisiSayisi = 0;
     // var olusturanPersonel = this.ortak.storagePersonelGetir.ID;
      formData.append("rezerve_durum", rezerveDurum.toString());
      formData.append("kaynak_ref", kaynakRef);
      formData.append("rezerve_eden", rezerveEden);
      formData.append("siparis_tip", siparisTip);
      formData.append("kisi_sayisi", kisiSayisi.toString());
    //  formData.append("olusturan_personel", olusturanPersonel);
      formData.append("siparis_baslik_durum_id", siparisDurumID);
      this.islem(formData, "OpMasaDetay", "", true).then(b => {
        var sonucMasaDetay = <any>b;
        var masa = { ID: masaID, MASA_ADI: masa_adi, BOLGE_ID: bolgeID, siparislerVeDetaylari: sonucMasaDetay.SonucObject };
 
        res(masa);
      }).catch(x => {
        err(x);
      })
    });
  }



}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-ortak.ts